<template>
  <v-container>
    <template>
      <v-row
        v-for="(item, i) in list"
        :key="i"
      >
        <v-col
          cols="1"
        >
          {{ item.id }}
        </v-col>
        <v-col
          cols="9"
        >
          {{ item.firstname }} {{ item.lastname }}
          <br/>
          {{ item.email }}
        </v-col>
        <v-col
          cols="2"
        >
          <v-btn
            @click="selectItem(item)"
          >
            Select
          </v-btn>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers'
export default {
  name: 'AppDataTable',
  props: ['search_param'],
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Firstname', value: 'firstname' },
      { text: 'Lastname', value: 'lastname' },
      { text: 'Email', value: 'email' },
      { text: 'Line ID', value: 'line_id' },
      { text: 'Phone number', value: 'phone_number' },
      { text: 'Facebook name', value: 'facebook_name' },
      { text: '', value: 'actions', sortable: false }
    ],
    list: [],
    count: 0,
    loading: true,
    page: 1,
    attribute_list: ['id', 'firstname', 'lastname', 'email',
      'phone_number', 'line_id', 'facebook_name', 'display_name']
  }),
  watch: {
    search_param: {
      async handler () {
        this.loading = true
        await this.getList()
      }
    }
  },
  methods: {
    async getList () {
      if (this.search_param == '')
        this.list = []
      else {
        let url = ``
        if (this.search_param)
          url += `${this.search_param}`
        url = url + `&sortby=id&ordering=ASC`
        const result = await this.$http.get(`/back-office/customers?${url}`, authHeader())
        const count = await this.$http.get(`/back-office/customers/count?${url}`, authHeader())
        this.count = count.data
        this.list = result.data.map(item => {
          let data = {}
          for (let attribute of this.attribute_list) {
            data[attribute] = item[attribute]
          }
          return data
        })
        // console.log(this.list)
        this.loading = false
      }
    },
    selectItem (customer) {
      this.list = []
      this.$emit('setCustomerId', customer)
    },
  }
}
</script>